/** Experiencia IKEA: arrastre desde malla, sin gizmo visible. */
export const MODULAR_IKEA_DRAG_ENABLED = true

/** Snap points, flechas y distancias en escena (activar en consola o HUD). */
export const MODULAR_SNAP_DEBUG_ENABLED =
  typeof window !== 'undefined' &&
  (window as Window & { __MODULAR_SNAP_DEBUG__?: boolean }).__MODULAR_SNAP_DEBUG__ === true

export const MODULAR_SNAP_REACH_MM = 900
export const MODULAR_SNAP_PREVIEW_REACH_MM = 1200
export const MODULAR_FLOOR_DRAG_MIN_PX = 4
